const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const T=v=>{const t=+new Date(v||0);return Number.isFinite(t)&&t>0?t:null};
const arr=v=>Array.isArray(v)?v:[];

const isCodeP=t=>String(t?.transaction_code||'').toUpperCase()==='P'&&String(t?.acquired_disposed||'').toUpperCase()==='A';
const isCodeS=t=>String(t?.transaction_code||'').toUpperCase()==='S'&&String(t?.acquired_disposed||'').toUpperCase()==='D';
const ownerNames=t=>arr(t?.owner_names).map(x=>String(x||'').trim()).filter(Boolean);

export function deriveInsiderEvidence(payload,now=new Date()){
 const nowMs=+new Date(now);
 if(!Number.isFinite(nowMs))return{status:'MISSING',state:'MISSING',transactions:[],note:'Insider evidence clock could not be evaluated.'};
 const sourceStatus=String(payload?.status||'MISSING').toUpperCase();
 if(!['VERIFIED','PARTIAL'].includes(sourceStatus))return{status:sourceStatus==='REVIEW'?'REVIEW':'MISSING',state:'MISSING',transactions:[],note:'Verified SEC Form 4 evidence is unavailable.'};

 const transactions=arr(payload?.transactions).filter(t=>T(t?.transaction_date)!=null&&T(t.transaction_date)<=nowMs).sort((a,b)=>T(b.transaction_date)-T(a.transaction_date));
 const purchases=transactions.filter(isCodeP),sales=transactions.filter(isCodeS);
 const since30=nowMs-30*864e5,since90=nowMs-90*864e5;
 const purchases30=purchases.filter(t=>T(t.transaction_date)>=since30),purchases90=purchases.filter(t=>T(t.transaction_date)>=since90);
 const sales30=sales.filter(t=>T(t.transaction_date)>=since30);
 const insiders30=[...new Set(purchases30.flatMap(ownerNames).map(x=>x.toUpperCase()))];
 const insiders90=[...new Set(purchases90.flatMap(ownerNames).map(x=>x.toUpperCase()))];
 const shares30=purchases30.reduce((s,t)=>s+(N(t?.shares)||0),0);
 const shares90=purchases90.reduce((s,t)=>s+(N(t?.shares)||0),0);

 let state='NO_RECENT_CODE_P';
 if(purchases30.length&&insiders30.length>=2)state='CLUSTER_CODE_P';
 else if(purchases30.length)state='RECENT_CODE_P';
 else if(purchases90.length)state='OLDER_CODE_P';
 else if(sourceStatus==='PARTIAL')state='REVIEW';

 return{
  status:sourceStatus,
  state,
  source:'SEC Form 4',
  filingsScanned:N(payload?.filings_scanned)||0,
  filingFailures:N(payload?.filing_failures)||0,
  transactions,
  purchases30,
  purchases90,
  sales30,
  uniquePurchaseInsiders30:insiders30.length,
  uniquePurchaseInsiders90:insiders90.length,
  purchaseShares30:shares30||0,
  purchaseShares90:shares90||0,
  latestPurchaseDate:purchases[0]?.transaction_date||null,
  note:'Code P means an open-market or private purchase under SEC Form 4 transaction coding. This is evidence context, not a BUY/SELL signal or capital permission.'
 };
}
